/* eslint-disable */
import { Chip, FormControl, FormControlLabel, Grid, Paper, Typography } from '@material-ui/core';
import Radio from '@material-ui/core/Radio';
import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import cn from 'classnames';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators, compose } from 'redux';
import withServices from '../../Contexts/Services/WithServices.context';
import docketsActionCreators from '../../State/Store/Dockets/Dockets.actions';
import filtersActionCreators from '../../State/Store/Filters/Filters.actions';
import getFiltersSelectedAccount from '../../State/Store/Filters/Selectors/FiltersSelectedAccount.selector';
import uiActionCreators from '../../State/Store/UI/UI.actions';
import { UI_ORDER_STATUS_SELECTOR_CONFIRMED, UI_ORDER_STATUS_SELECTOR_TO_BE_CONFIRMED } from '../../State/Store/UI/UI.types';
import userProfileSelector from '../../State/Store/UserProfile/Selectors/UserProfileCurrent.selector';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import placeOrderStyles from './PlaceOrder.component.styles';
import Hidden from '@material-ui/core/Hidden';

/**
 * OrderStatusSelector
 * @param {any} props The props
 * @returns {React.Component} The component
 */
const OrderStatusSelector = ({ actions, classes, onChange, defaultStatus, mandatoryFieldError }) => {
  const [orderStatus, setOrderStatus] = useState(typeof defaultStatus === `boolean` ? defaultStatus : null);

  /**
   * Sets order status and informs parent about changes
   * @param {boolean} confirmed status selected
   * @returns {void} void
   */
  const onStatusOrderHandle = (confirmed, e) => {
    if (confirmed) {
      actions.uiTriggered({
        payload: {
          data: {
            name: `accountOrderStatusSelectorConfirmed`,
          },
        },
        type: UI_ORDER_STATUS_SELECTOR_CONFIRMED,
      });
    } else {
      actions.uiTriggered({
        payload: {
          data: {
            name: `accountOrderStatusSelectorToBeConfirmed`,
          },
        },
        type: UI_ORDER_STATUS_SELECTOR_TO_BE_CONFIRMED,
      });
    }
    setOrderStatus(confirmed);
    onChange({ isValid: true, confirmed });
    e.preventDefault();
    return;
  };

  /**
   * Rende Confirm Now
   * @returns {React.Component} The component
   */
  const renderConfirmNow = () => {
    return (
      <Grid container spacing={2} className={classes.flexWrapNowrap}>
        <Grid item className={classes.flexGrow1}>
          <Hidden smUp>
            <Chip className={cn(classes.marginBottom1unit, classes.cursorPointer, orderStatus === true ? classes.confirmedChip : classes.greyChip)} label="Confirmed" />
           </Hidden>
          <Typography variant="h6">Confirm Now</Typography>
          <Typography variant="body2" className={classes.confirmCopy}>
            Your order will start delivering at the start date/time without any further action from you.
          </Typography>
        </Grid>
      </Grid>
    );
  };

  /**
   * Rende To Be Confirmed
   * @returns {React.Component} The component
   */
  const renderToBeConfirmed = () => {
    return (
      <Grid container spacing={2} className={classes.flexWrapNowrap}>
        <Grid item className={classes.flexGrow1}>
          <Hidden smUp>
            <Chip className={cn(classes.marginBottom1unit, classes.cursorPointer, orderStatus === false ? classes.toBeConfirmedChip : classes.greyChip)} label="To Be Confirmed" />
          </Hidden>
          <Typography variant="h6" className={classes.marginTop1Unit}>Confirm Later</Typography>
          <Typography variant="body2" className={classes.confirmCopy}>
            Your order will be placed but you will still need to Confirm (aka Activate) your order later. An SMS reminder will be sent.
          </Typography>
        </Grid>
      </Grid>
    );
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="body1">After your order is accepted by Boral, the order status can be set to either of the below:</Typography>
      </Grid>
      <Grid item xs={12}>
        <FormControl component="fieldset" className={classes.formControl}>
          <Paper className={cn(mandatoryFieldError ? classes.orderConfirmStatusError : null, classes.cursorPointer, classes.root, classes.marginBottom2unit)} elevation={1} onClick={(e) => onStatusOrderHandle(true, e)}>
            <Grid container spacing={2} className={classes.flexWrapNowrap}>
              <Grid item className={classes.flexGrow1}>
                <FormControlLabel
                  value="1"
                  checked={!!orderStatus}
                  control={<Radio color="primary" />}
                  label={renderConfirmNow()}
                  classes={{ root: classes.confirmWidth, label: classes.radioButton }}
                />
              </Grid>
              <Hidden xsDown>
                <Grid item>
                  <Chip className={cn(classes.cursorPointer, orderStatus === true ? classes.confirmedChip : classes.greyChip)} label="Confirmed" />
                </Grid>
              </Hidden>
            </Grid>
          </Paper>
          <Paper className={cn(mandatoryFieldError ? classes.orderConfirmStatusError : null, classes.cursorPointer, classes.root)} elevation={1} onClick={(e) => onStatusOrderHandle(false, e)}>
            <Grid container spacing={2} className={classes.flexWrapNowrap}>
              <Grid item className={classes.flexGrow1}>
                <FormControlLabel
                  value="0"
                  checked={orderStatus !== null && !orderStatus}
                  control={<Radio color="primary" />}
                  label={renderToBeConfirmed()}
                  classes={{ root: classes.confirmWidth, label: classes.radioButton }}
                />
              </Grid>
              <Hidden xsDown>
                <Grid item>
                  <Chip className={cn(classes.cursorPointer, orderStatus === false ? classes.toBeConfirmedChip : classes.greyChip)} label="To Be Confirmed" />
                </Grid>
              </Hidden>
            </Grid>
          </Paper>
        </FormControl>
      </Grid>
    </Grid>
  );
};

/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
OrderStatusSelector.propTypes = {
  actions: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  defaultStatus: PropTypes.bool,
};

export default compose(
  withWidth(),
  withRouter,
  withServices,
  connect(
    (state) => ({
      listSettings: state.dockets ? state.dockets.listSettings : null,
      userInfo: userProfileSelector(state),
      currentDateTimeGlobal: getFiltersSelectedAccount(state),
    }),
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...uiActionCreators,
          ...filtersActionCreators,
          ...docketsActionCreators,
        },
        dispatch,
      ),
    }),
  ),
  withStyles(themeCreateInjectableStyles(placeOrderStyles), { withTheme: true }),
)(OrderStatusSelector);
